// PrincipleCard.jsx
import React from 'react';
import './PrincipleCard.css';
import arrow from "../../../assets/images/Hero/top-right.png"

const PrincipleCard = ({ 
  number, 
  title, 
  description, 
  width = "300px",
  height = "250px",
  className = ""
}) => {
  const cardStyle = {
    width: width,
    height: height
  };

  return (
    <div 
      className={`principle-card ${className}`} 
      style={cardStyle}
    >
      <div className="principle-card__header">
        <div className="principle-card__number">{number}</div>
        <div className="principle-card__arrow">
        <img src={arrow} alt="arrow" />
        </div>
      </div>
      <div className="principle-card__content">
        <h3 className="principle-card__title">{title}</h3>
        <p className="principle-card__description">{description}</p>
      </div>
        </div>
  );
};


export default PrincipleCard;